<template>
	<div class="login-container">
		<!-- 动态背景 -->
		<div class="animated-background">
			<div class="floating-shapes">
				<div class="shape shape-1" v-for="i in 8" :key="`shape1-${i}`"></div>
				<div class="shape shape-2" v-for="i in 6" :key="`shape2-${i}`"></div>
				<div class="shape shape-3" v-for="i in 4" :key="`shape3-${i}`"></div>
			</div>
			<div class="gradient-overlay"></div>
			<div class="light-rays"></div>
		</div>
		
		<!-- 主登录区域 -->
		<div class="login-wrapper">
			<!-- 左侧装饰区域 -->
			<div class="login-decoration">
				<div class="decoration-circle circle-1"></div>
				<div class="decoration-circle circle-2"></div>
				<div class="decoration-circle circle-3"></div>
				<div class="welcome-text">
					<h2>欢迎回来</h2>
					<p>开启您的智能通讯之旅</p>
				</div>
			</div>
			
			<!-- 登录表单卡片 -->
			<div class="login-card">
				<div class="card-glow-effect"></div>
				<div class="login-header">
					<div class="logo-section">
						<div class="logo-wrapper">
							<img src="@/assets/common/logo.png" class="logo" />
							<div class="logo-aura"></div>
						</div>
						<h1 class="brand-title">
							<span class="title-main">丝路畅聊</span>
							<span class="title-sub">Silk Messenger</span>
						</h1>
					</div>
				</div>
				
				<el-form class="elegant-form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
					@keyup.enter.native="submitForm('loginForm')">
					<el-form-item prop="userName" v-show="false">
						<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
					</el-form-item>
					
					<div class="input-group">
						<el-form-item prop="userName">
							<el-input 
								type="userName" 
								v-model="loginForm.userName" 
								autocomplete="off"
								:placeholder="loginNamePlaceholder" 
								prefix-icon="el-icon-user" 
								maxLength="11"
								clearable>
							</el-input>
							<div class="input-highlight"></div>
						</el-form-item>
						
						<el-form-item prop="password">
							<el-input 
								type="password" 
								v-model="loginForm.password" 
								autocomplete="off" 
								placeholder="请输入密码"
								prefix-icon="el-icon-lock" 
								clearable>
							</el-input>
							<div class="input-highlight"></div>
						</el-form-item>
						
						<el-form-item prop="verifyCode">
							<div class="captcha-row">
								<el-input
									v-model="loginForm.verifyCode"
									autocomplete="off"
									placeholder="请输入图形验证码"
									maxlength="6"
									clearable
									class="captcha-input">
								</el-input>
								<div class="captcha-img-wrap" @click="loadCaptchaImage" title="点击刷新">
									<img v-if="captchaImage" :src="captchaImage" class="captcha-img" alt="验证码" />
									<span v-else class="captcha-loading">加载中...</span>
								</div>
							</div>
							<div class="input-highlight"></div>
						</el-form-item>
					</div>
					
					<div class="action-buttons">
						<el-button type="primary" class="login-btn" @click="submitForm('loginForm')" v-loading="loading">
							<span class="btn-content">
								<i class="el-icon-right"></i>
								立即登录
							</span>
							<div class="btn-ripple"></div>
						</el-button>
						<el-button class="clear-btn" @click="resetForm('loginForm')">
							<span class="btn-content">清空表单</span>
						</el-button>
					</div>
					
					<div class="bottom-actions">
						<div class="download-section">
							<a :href="$store.state.configStore.app.downloadUrl" target="_blank" class="download-link">
								<div class="download-icon">
									<img src="@/assets/common/cdownload.png" />
								</div>
								<span>下载App</span>
							</a>
						</div>
						<div class="register-section">
							<router-link to="/register" class="register-link">
								<span>没有账号？</span>
								<span class="highlight">立即注册</span>
							</router-link>
						</div>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "login",
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		var checkVerifyCode = (rule, value, callback) => {
			if (!value || !value.trim()) {
				return callback(new Error('请输入图形验证码'));
			}
			callback();
		};
		return {
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: '',
				uuid: '',
				verifyCode: ''
			},
			captchaImage: '',
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				verifyCode: [{
					validator: checkVerifyCode,
					trigger: 'blur'
				}]
			},
			loading: false,
		};
	},
	methods: {
		loadCaptchaImage() {
			this.$http({
				url: "/captcha/img/code",
				method: 'post'
			}).then((data) => {
				this.loginForm.uuid = data.id || data.uuid;
				this.captchaImage = data.image ? ('data:image/gif;base64,' + data.image) : '';
			}).catch(() => {
				this.$message.error('验证码加载失败');
			});
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					})
						.then((data) => {
							// 保存密码到cookie(不安全)
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							// 保存token
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);
							this.$message.success("登录成功");
							this.$router.push("/home/chat");
						})
						.catch(() => {
							this.loadCaptchaImage();
							this.loginForm.verifyCode = '';
						})
						.finally(() => {
							this.loading = false;
						});
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.loadCaptchaImage();
		},
		// 获取cookie、
		getCookie(name) {
			let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			let arr = document.cookie.match(reg)
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		// 设置cookie,增加到vue实例方便全局调用
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		}
	},
	mounted() {
		this.loginForm.userName = this.getCookie("username");
		// cookie存密码并不安全，暂时是为了方便
		this.loginForm.password = this.getCookie("password");
		this.loadCaptchaImage();
	},
	computed: {
		loginNamePlaceholder() {
			let mode = this.$store.state.configStore.registration.mode;
			let strText = "用户名";
			if (mode.includes("phone")) {
				strText += "/手机号"
			}
			if (mode.includes("email")) {
				strText += "/邮箱"
			}
			return "请输入手机号";
			// return strText;
		}
	}
}
</script>

<style scoped lang="scss">
.login-container {
	width: 100%;
	height: 100vh;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #129a96 0%, #0d7a77 100%);
	
	// 动态背景
	.animated-background {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		
		.floating-shapes {
			position: absolute;
			width: 100%;
			height: 100%;
			
			.shape {
				position: absolute;
				border-radius: 50%;
				background: rgba(255, 255, 255, 0.1);
				animation: float 6s ease-in-out infinite;
				
				&.shape-1 {
					width: 80px;
					height: 80px;
					top: 20%;
					left: 10%;
					animation-delay: 0s;
					animation-duration: 8s;
				}
				
				&.shape-2 {
					width: 120px;
					height: 120px;
					top: 60%;
					right: 15%;
					animation-delay: 2s;
					animation-duration: 10s;
				}
				
				&.shape-3 {
					width: 60px;
					height: 60px;
					bottom: 30%;
					left: 20%;
					animation-delay: 4s;
					animation-duration: 12s;
				}
			}
		}
		
		.gradient-overlay {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
					background: radial-gradient(circle at 30% 20%, rgba(18, 154, 150, 0.3) 0%, transparent 50%),
					radial-gradient(circle at 70% 80%, rgba(13, 122, 119, 0.3) 0%, transparent 50%);
		}
		
		.light-rays {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
			animation: lightSweep 8s ease-in-out infinite;
		}
	}
	
	// 主登录区域
	.login-wrapper {
		position: relative;
		z-index: 10;
		display: flex;
		align-items: center;
		gap: 60px;
		max-width: 1200px;
		width: 100%;
		padding: 0 40px;
		
		// 左侧装饰区域
		.login-decoration {
			flex: 1;
			position: relative;
			height: 600px;
			display: flex;
			align-items: center;
			justify-content: center;
			
			.decoration-circle {
				position: absolute;
				border-radius: 50%;
				background: linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
				backdrop-filter: blur(10px);
				border: 1px solid rgba(255, 255, 255, 0.2);
				
				&.circle-1 {
					width: 200px;
					height: 200px;
					top: 20%;
					left: 10%;
					animation: pulse 4s ease-in-out infinite;
				}
				
				&.circle-2 {
					width: 150px;
					height: 150px;
					bottom: 30%;
					right: 20%;
					animation: pulse 4s ease-in-out infinite 1s;
				}
				
				&.circle-3 {
					width: 100px;
					height: 100px;
					top: 60%;
					left: 60%;
					animation: pulse 4s ease-in-out infinite 2s;
				}
			}
			
			.welcome-text {
				text-align: center;
				color: white;
				z-index: 2;
				
				h2 {
					font-size: 3rem;
					font-weight: 700;
					margin: 0 0 20px 0;
					background: linear-gradient(45deg, #fff, #f0f0f0);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
					animation: titleGlow 3s ease-in-out infinite;
				}
				
				p {
					font-size: 1.2rem;
					opacity: 0.9;
					margin: 0;
					letter-spacing: 1px;
				}
			}
		}
		
		// 登录卡片
		.login-card {
			flex: 1;
			max-width: 480px;
			position: relative;
			background: rgba(255, 255, 255, 0.98);
			backdrop-filter: blur(20px);
			border-radius: 24px;
			padding: 40px;
			box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
			border: 1px solid rgba(255, 255, 255, 0.3);
			overflow: hidden;
			
			.card-glow-effect {
				position: absolute;
				top: -50%;
				left: -50%;
				width: 200%;
				height: 200%;
				background: radial-gradient(circle, rgba(18, 154, 150, 0.1) 0%, transparent 70%);
				animation: cardGlow 6s ease-in-out infinite;
				pointer-events: none;
			}
			
			.login-header {
				text-align: center;
				margin-bottom: 40px;
				
				.logo-section {
					.logo-wrapper {
						position: relative;
						display: inline-block;
						margin-bottom: 20px;
						
						.logo {
							width: 80px;
							height: 80px;
							border-radius: 20px;
							position: relative;
							z-index: 2;
							animation: logoFloat 3s ease-in-out infinite;
						}
						
						.logo-aura {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							width: 100px;
							height: 100px;
							background: radial-gradient(circle, rgba(102, 126, 234, 0.3) 0%, transparent 70%);
							border-radius: 50%;
							animation: auraPulse 2s ease-in-out infinite;
						}
					}
					
					.brand-title {
						margin: 0;
						
						.title-main {
							display: block;
							font-size: 2.2rem;
							font-weight: 700;
							background: linear-gradient(135deg, #667eea, #764ba2);
							-webkit-background-clip: text;
							-webkit-text-fill-color: transparent;
							background-clip: text;
							margin-bottom: 8px;
						}
						
						.title-sub {
							display: block;
							font-size: 1rem;
							color: #555;
							font-weight: 500;
							letter-spacing: 2px;
							text-transform: uppercase;
						}
					}
				}
			}
			
			.elegant-form {
				.input-group {
					margin-bottom: 30px;
					
					.el-form-item {
						margin-bottom: 25px;
						position: relative;
						
						.el-input {
							::v-deep .el-input__inner {
								height: 56px;
								border: 2px solid #e1e5e9;
								border-radius: 16px;
								padding-left: 45px;
								font-size: 16px;
								background: rgba(255, 255, 255, 0.95);
								color: #333;
								font-weight: 500;
								transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
								line-height: 56px;
								
								&::placeholder {
									color: #666;
									font-weight: 400;
								}
								
								&:focus {
									border-color: #129a96;
									box-shadow: 0 0 0 4px rgba(18, 154, 150, 0.1);
									background: white;
									color: #333;
								}
								
								&:hover {
									border-color: #4db3af;
									background: rgba(255, 255, 255, 0.98);
								}
							}
							
							::v-deep .el-input__prefix {
								left: 20px;
								color: #129a96;
								font-size: 18px;
								line-height: 56px;
								display: flex;
								align-items: center;
							}
						}
						
						.input-highlight {
							position: absolute;
							bottom: 0;
							left: 50%;
							width: 0;
							height: 2px;
							background: linear-gradient(90deg, #129a96, #0d7a77);
							transition: all 0.3s ease;
							transform: translateX(-50%);
						}
						
						&:focus-within .input-highlight {
							width: 100%;
						}
						
						.captcha-row {
							display: flex;
							align-items: center;
							gap: 12px;
							width: 100%;
							
							.captcha-input {
								flex: 1;
								
								::v-deep .el-input__inner {
									padding-left: 16px;
								}
							}
							
							.captcha-img-wrap {
								flex-shrink: 0;
								width: 120px;
								height: 56px;
								display: flex;
								align-items: center;
								justify-content: center;
								background: rgba(245, 245, 245, 0.95);
								border-radius: 12px;
								cursor: pointer;
								overflow: hidden;
								border: 2px solid #e1e5e9;
								transition: border-color 0.3s ease;
								
								&:hover {
									border-color: #4db3af;
								}
								
								.captcha-img {
									width: 100%;
									height: 100%;
									object-fit: contain;
									display: block;
								}
								
								.captcha-loading {
									font-size: 12px;
									color: #999;
								}
							}
						}
					}
				}
				
				.action-buttons {
					margin-bottom: 30px;
					
					.login-btn {
						width: 100%;
						height: 56px;
						border-radius: 16px;
						background: linear-gradient(135deg, #129a96, #0d7a77);
						border: none;
						position: relative;
						overflow: hidden;
						margin-bottom: 15px;
						transition: all 0.3s ease;
						
						&:hover {
							transform: translateY(-2px);
							box-shadow: 0 10px 30px rgba(18, 154, 150, 0.3);
						}
						
						&:active {
							transform: translateY(0);
						}
						
						.btn-content {
							position: relative;
							z-index: 2;
							font-size: 16px;
							font-weight: 600;
							color: white;
							display: flex;
							align-items: center;
							justify-content: center;
							gap: 8px;
						}
						
						.btn-ripple {
							position: absolute;
							top: 50%;
							left: 50%;
							width: 0;
							height: 0;
							background: rgba(255, 255, 255, 0.3);
							border-radius: 50%;
							transform: translate(-50%, -50%);
							transition: all 0.6s ease;
						}
						
						&:active .btn-ripple {
							width: 300px;
							height: 300px;
						}
					}
					
					.clear-btn {
						width: 100%;
						height: 48px;
						border-radius: 12px;
						border: 2px solid #e1e5e9;
						background: transparent;
						color: #555;
						font-weight: 600;
						transition: all 0.3s ease;
						margin-left: 0!important;
						&:hover {
							border-color: #129a96;
							color: #129a96;
							background: rgba(18, 154, 150, 0.05);
						}
					}
				}
				
				.bottom-actions {
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					.download-section {
						.download-link {
							display: flex;
							align-items: center;
							gap: 8px;
							color: #129a96;
							text-decoration: none;
							font-weight: 600;
							padding: 8px 16px;
							border-radius: 12px;
							transition: all 0.3s ease;
							
							&:hover {
								background: rgba(18, 154, 150, 0.1);
								transform: translateY(-1px);
							}
							
							.download-icon {
								width: 20px;
								height: 20px;
								
								img {
									width: 100%;
									height: 100%;
									object-fit: contain;
								}
							}
						}
					}
					
					.register-section {
						.register-link {
							text-decoration: none;
							color: #555;
							font-size: 14px;
							font-weight: 500;
							transition: all 0.3s ease;
							
							&:hover {
								color: #129a96;
							}
							
							.highlight {
								color: #129a96;
								font-weight: 700;
								margin-left: 4px;
							}
						}
					}
				}
			}

			.captcha-row {
				display: flex;
				align-items: center;
				gap: 12px;
				width: 100%;

				.captcha-input {
					flex: 1;
				}

				.captcha-img-wrap {
					flex-shrink: 0;
					width: 120px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #f5f8ff;
					border-radius: 4px;
					cursor: pointer;
					overflow: hidden;
					border: 1px solid #dcdfe6;

					&:hover {
						border-color: #2b80f2;
					}

					.captcha-img {
						width: 100%;
						height: 100%;
						object-fit: contain;
						display: block;
					}

					.captcha-loading {
						font-size: 12px;
						color: #999;
					}
				}
			}
		}
	}
}

// 动画定义
@keyframes float {
	0%, 100% {
		transform: translateY(0px) rotate(0deg);
	}
	50% {
		transform: translateY(-20px) rotate(180deg);
	}
}

@keyframes lightSweep {
	0%, 100% {
		opacity: 0;
		transform: translateX(-100%);
	}
	50% {
		opacity: 1;
		transform: translateX(100%);
	}
}

@keyframes pulse {
	0%, 100% {
		transform: scale(1);
		opacity: 0.7;
	}
	50% {
		transform: scale(1.1);
		opacity: 1;
	}
}

@keyframes titleGlow {
	0%, 100% {
		filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
	}
	50% {
		filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));
	}
}

@keyframes cardGlow {
	0%, 100% {
		opacity: 0.3;
		transform: rotate(0deg);
	}
	50% {
		opacity: 0.6;
		transform: rotate(180deg);
	}
}

@keyframes logoFloat {
	0%, 100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-5px);
	}
}

@keyframes auraPulse {
	0%, 100% {
		transform: translate(-50%, -50%) scale(1);
		opacity: 0.5;
	}
	50% {
		transform: translate(-50%, -50%) scale(1.2);
		opacity: 0.8;
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.login-container {
		.login-wrapper {
			flex-direction: column;
			gap: 40px;
			padding: 20px;
			
			.login-decoration {
				height: 300px;
				
				.welcome-text h2 {
					font-size: 2.5rem;
				}
			}
			
			.login-card {
				max-width: 100%;
				padding: 30px;
			}
		}
	}
}

@media (max-width: 768px) {
	.login-container {
		.login-wrapper {
			.login-decoration {
				display: none;
			}
			
			.login-card {
				padding: 25px;
				
				.login-header .logo-section .brand-title .title-main {
					font-size: 1.8rem;
				}
			}
		}
	}
}
</style>